import { motion } from "framer-motion";
import { Droplets, Heart, Flame, BookOpen, FileText, GraduationCap, HandCoins } from "lucide-react";
import { SHORTCUTS, WHATSAPP_URL } from "@/data/content";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";
import { scrollToId } from "@/lib/scroll";

const ICONS = { Droplets, Heart, Flame, BookOpen, FileText, GraduationCap, HandCoins };

export default function Shortcuts() {
  return (
    <section id="atendimento" className="px-4 sm:px-8 lg:px-16 py-20 lg:py-32">
      <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}>
        <motion.p variants={fadeUp} className="overline-label text-[#4A0E17]/60">Atendimento Pastoral</motion.p>
        <motion.h2 variants={fadeUp} className="font-display mt-4 max-w-3xl text-4xl sm:text-5xl font-bold uppercase leading-tight text-[#1C1917]">
          Como podemos servir você
        </motion.h2>

        <div className="mt-12 flex flex-wrap gap-4">
          {SHORTCUTS.map((s) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.button
                key={s.testid}
                variants={fadeUp}
                data-testid={s.testid}
                onClick={() => scrollToId(s.target)}
                className="group flex items-center gap-3 border border-[#E5DEC9] bg-[#FBF9F4] px-6 py-4 hover:border-[#4A0E17] hover:bg-[#4A0E17] transition-colors duration-400"
              >
                <Icon className="h-5 w-5 text-[#4A0E17] group-hover:text-[#C5A059] transition-colors duration-400" strokeWidth={1.6} />
                <span className="font-display text-sm font-bold text-[#1C1917] group-hover:text-[#FBF9F4] transition-colors duration-400">{s.title}</span>
              </motion.button>
            );
          })}
        </div>

        <motion.p variants={fadeUp} className="mt-10 text-sm text-[#1C1917]/60">
          Para agendamentos de batismo, matrimônio, catequese e acompanhamento vocacional, fale com a Chancelaria pelo{" "}
          <a data-testid="shortcuts-whatsapp-link" href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="text-[#4A0E17] font-semibold border-b border-[#C5A059] hover:text-[#C5A059] transition-colors">
            WhatsApp Pastoral
          </a>.
        </motion.p>
      </motion.div>
    </section>
  );
}
